import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/romance', label: '恋爱漫画' },
    { to: '/category/action', label: '热血动作' },
    { to: '/category/fantasy', label: '奇幻冒险' },
    { to: '/about', label: '关于我们' },
  ];

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      window.REACT_APP_NAVIGATE(`/category/all?search=${encodeURIComponent(searchQuery.trim())}`);
      setSearchQuery('');
      setSearchOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-book-open-line text-background-50 text-lg"></i>
            </div>
            <span className={`font-heading text-xl font-bold ${scrolled ? 'text-foreground-900' : 'text-white'}`}>
              韩漫画网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === link.to
                    ? scrolled ? 'text-primary-500' : 'text-white font-semibold'
                    : scrolled ? 'text-foreground-700 hover:text-primary-500' : 'text-white/80 hover:text-white'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="flex items-center gap-3">
            <div className="relative">
              {searchOpen ? (
                <form onSubmit={handleSearch} className="flex items-center">
                  <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="搜索漫画..."
                    className="w-48 md:w-56 h-9 px-4 text-sm rounded-full border border-background-300 bg-background-50 text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                    autoFocus
                    onBlur={() => {
                      if (!searchQuery.trim()) setSearchOpen(false);
                    }}
                  />
                </form>
              ) : (
                <button
                  onClick={() => setSearchOpen(true)}
                  className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors ${
                    scrolled
                      ? 'text-foreground-700 hover:bg-background-100'
                      : 'text-white/80 hover:text-white'
                  }`}
                  aria-label="搜索"
                >
                  <i className="ri-search-line text-lg"></i>
                </button>
              )}
            </div>

            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-full"
              aria-label="菜单"
            >
              <i className={`text-xl ${scrolled ? 'text-foreground-900' : 'text-white'} ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === link.to
                    ? 'bg-primary-50 text-primary-600'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <form onSubmit={handleSearch} className="mt-2">
              <div className="flex items-center gap-2">
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="搜索漫画..."
                  className="flex-1 h-9 px-4 text-sm rounded-full border border-background-300 bg-background-100 text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-400"
                />
                <button
                  type="submit"
                  className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-full whitespace-nowrap"
                  aria-label="搜索"
                >
                  <i className="ri-search-line"></i>
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </nav>
  );
}